export default {
    bookpayment_public: 'x13001',
}